






















import {Component, Vue, Prop} from 'vue-property-decorator'
import ListItem from '@/components/list/ListItem.vue'

@Component({
  components: {ListItem},
})
export default class ToggleCollapseButton extends Vue {
  @Prop({default: false, type: Boolean}) isActive: boolean
  @Prop({default: '', type: String}) title: string
  @Prop({default: false, type: Boolean}) disabled: boolean
}
